import Vue from "vue";
// const BASE_URL = "http://192.168.0.105:7001";
// const BASE_URL = "https://ryit.natapp4.cc";
const BASE_URL = "https://api.ccenews.com.cn";
sessionStorage.setItem("$url", BASE_URL);
const API = {

  logining: `/api/web/login`, //测试登录
  viplist: `/member/web/list`, //查询用户列表
  detailslist: `/dict/web/details/list`, // 根据字典类型获取数据字典
  applylist: `/apply/web/list`, // 会员申请分页列表查询
  applydel : `/apply/web/del/`, // 删除会员申请审批管理
  applyreject : `/apply/web/reject`, // 审批驳回
  applyadopt : `/apply/web/adopt`, // 审批驳回
  applybatch : `/apply/web/adopt/batch`, // 批量审批会员申请
  columnlists : `/column/web/list`, // 查询栏目管理列表分页
  columndel : `/column/web/del/`, // 删除栏目
  columnsave : `/column/web/save`, // 新增栏目管理
  columnupdate : `/column/web/update`, // 修改栏目管理
  periodicallist : `/periodical/web/list`, // 查询期刊管理列表分页
  periodicaldel : `/periodical/web/del/`, // 删除期刊
  periodicalupload : `/periodical/web/upload`, // 上传单个文件
  periodicalsave : `/periodical/web/save`, // 上传单个文件
  periodicalupdate : `/periodical/web/update`, // 期刊修改
  periodicalreupload : `/periodical/web/reupload`, // 重新上传
  articlelist: `/article/web/list`, // 文章管理列表
  periodicalselectlist: `/periodical/web/select/list`, // 期刊下拉
  articledel: `/article/web/del/`, // 删除期刊
  periodicalyear: `/periodical/web/select/year`, // 期刊年份下拉框
  periodicalyear: `/periodical/web/select/year`, // 期刊年份下拉框
  periodicalmonth: `/periodical/web/select/month`, // 根据期刊年份获取期刊月份下拉框
  dictlist: `/dict/web/details/list`, // 来源
  columnlist: `/column/web/select/list`, // 栏目下拉
  articlesave: `/article/web/save`, // 保存文章
  articleinfo: `/article/web/info`, // 修改文章回显
  articleupdate: `/article/web/update`, // 修改文章
  userlist: `/user/web/list`, // 用户列表
  rolelist: `/role/web/select/list`, // 角色
  userdel: `/user/web/del/`, // 输出用户
  usersave: `/user/web/save`, // 新增用户
  userreset: `/user/web/reset`, // 重置密码
  rolelists: `/role/web/list`, // 角色列表
  roledel: `/role/web/del/`, // 角色删除
  rolesave: `/role/web/save`, // 角色新增
  roleupdate: `/role/web/update`, // 角色修改
  permissiontree: `/permission/web/tree`, // 查询权限树形结构-后端管理权限管理
  rolepermission: `/role/web/permission/`, // 获取角色拥有的权限
  rolesaves: `/role/web/permission/save/`, // 分配角色权限
  loginLoglist: `/loginLog/web/list`, // 分配角色权限
  loginLogprohibitiont: `/loginLog/web/prohibition`, // 封IP
  loginLogdeblocking: `/loginLog/web/deblocking`, // 解IP
  dicttree: `/dict/web/tree`, // 字典树形结构查询
  dictdel: `/dict/web/del/`, // 字典删除
  dictlists: `/dict/web/select/list`, // 字典删除
  dictsave: `/dict/web/save`, // 字典新增
  dictinfo: `/dict/web/info/`, // 获取字典
  dictupdate: `/dict/web/update`, // 权限列表
  permissiondel: `/permission/web/del/`, // 权限删除
  permissionlist: `/permission/web/select/list`, //  权限父节点
  permissionsave: `/permission/web/save`, // 权限新增
  permissionupdate: `/permission/web/update`, // 权限新增
  permissionuser: `/permission/web/user/`, // 左侧菜单
  userupdate: `/user/web/role/update`, // 更改角色
  articlehtml:`/article/web/info/`,//阅读文章
  memberdel: `/member/web/del/`, //删除会员
  updatePassword: `/user/web/updatePassword`, //修改用户密码
  judge: `/user/web/judge` //校验原密码
  };
Vue.prototype.$api = API;
export default {
  API,
  BASE_URL
};
